export default __webpack_public_path__ + "static/media/catIcon.db5d355a.svg";